import { createListenerMiddleware } from '@reduxjs/toolkit';

import type { RootState } from '@/store/rootReducer';
import { registerIncomingAuthListeners } from '@/store/listeners/poc/registerIncomingAuthListeners';
import { registerIncomingFileRefreshListeners } from '@/store/listeners/poc/registerIncomingFileRefreshListeners';
import { registerIncomingMaintenanceListeners } from '@/store/listeners/poc/registerIncomingMaintenanceListeners';
import { registerIncomingReplicationListeners } from '@/store/listeners/poc/registerIncomingReplicationListeners';
import type { AppServices } from '@/types/services.types';
import type { AppDispatch } from '@/store/listeners/types';

export function createAppListeners(services: AppServices) {
  const listenerMiddleware = createListenerMiddleware<RootState, AppDispatch, AppServices>({
    extra: services,
  });

  const startAppListening = listenerMiddleware.startListening.withTypes<
    RootState,
    AppDispatch,
    AppServices
  >();

  registerIncomingMaintenanceListeners(startAppListening);
  registerIncomingFileRefreshListeners(startAppListening);
  registerIncomingReplicationListeners(startAppListening);
  registerIncomingAuthListeners(startAppListening);

  return { listenerMiddleware };
}
